// test5
(5 && 0);
